import { useTranslation } from 'react-i18next'

import { wwtMemo } from '@wwt/custom/wwt'

import { wwtPerformanceLog } from '@wwt/core/admin'
import { OfferStatus, ReservationDto } from '@wwt/entities/api/search-response'
import { FeatureIsNotImplemented } from '@wwt/ui/components'

import { showSupplierInfoInReservation } from '@/shared/types/statuses'

interface GuestInformationReferenceInformationProps {
	status: keyof typeof OfferStatus
	reservation: ReservationDto
}

/**
 * Show reference information of reservation
 *
 * @author Ivan Shchedrovskyi
 */
export const GuestInformationReferenceInformation = wwtMemo(
	({ reservation, status }: GuestInformationReferenceInformationProps) => {
		wwtPerformanceLog('GuestInformationReferenceInformation')

		const { t } = useTranslation('room-page', {
			keyPrefix: 'reservationTab.referenceInformation'
		})

		return (
			<article>
				<h2 className="ts-headline-4 mb-4">{t('title')}</h2>

				<div className="flex flex-col gap-y-5 sm:gap-y-4">
					<FeatureIsNotImplemented>
						<div
							// TODO: Use link styles instead
							className="ts-hyperlink-button-2 decoration-skip-ink-none text-primary-100 underline decoration-2"
						>
							{t('hotelbedsBooking')}
						</div>
					</FeatureIsNotImplemented>

					<FeatureIsNotImplemented>
						<div
							// TODO: Use link styles instead
							className="ts-hyperlink-button-2 decoration-skip-ink-none text-primary-100 underline decoration-2"
						>
							{t('agency')}
						</div>
					</FeatureIsNotImplemented>

					{showSupplierInfoInReservation.includes(status) && (
						<div className="flex flex-col gap-y-2">
							<hr />

							<div className="ts-7 text-gray-400">
								{t('reference', {
									name: reservation.supplierInfoDto?.supplierName,
									vat: reservation.supplierInfoDto?.supplierVat,
									reference: reservation.integrationBookingReference
								})}
							</div>
						</div>
					)}
				</div>
			</article>
		)
	}
)
